import Faq from './Faq';

const faqs = document.querySelectorAll('[data-faq-group]');

[...faqs].forEach((faqElement) => {
    const faq = new Faq(faqElement);
    faq.init();
});
